export const SettingWizardStep = Object.freeze({
  START_SETUP_STEP: 1, // スタートセットアップテップ.
  GENERAL_SETTING_STEP: 2, // 一般設定ステップ.
  APP_SETTING_STEP: 3, // アプリごとの設定ステップ.
  UPLOAD_STEP: 4, // アップロードステップ.
  START_RCS_STEP: 5, // RCSの起動ステップ.
  DEVICE_SETTING_STEP: 6 // デバイス設定ステップ.
})



// WEBPACK FOOTER //
// ./src/enums/setting-wizard-step.enums.js